import {
  IN_PROGRESS,
  ERROR,
  SUCCESS,
  TIMEOUT,
} from './constants'

import { primary } from 'hfty-styles/src/colors'
import { error, white } from 'fc-styles/src/colors'

function statusColor (status) {
  switch (status) {
    case IN_PROGRESS:
      return primary()
    case ERROR:
      return error()
    case SUCCESS:
      return '#4CAF50'
    case TIMEOUT:
      return '#FFEE58'
    default:
      return '#BDBDBD'
  }
}

export const container = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 999,
}

export const maskedStyle = {
  zIndex: 5001,
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: 'rgba(0,0,0,0.2)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}

export const requestInfoStyle = (status) => ({
  zIndex: 5100,
  display: 'block',
  width: 250,
  flex: '0 0 auto',
  position: 'relative',
  paddingTop: 10,
  paddingBottom: 10,
  paddingLeft: 15,
  paddingRight: 15,
  backgroundColor: statusColor(status),
  boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
  borderLeft: '2px solid ' + statusColor(status),
  borderRadius: 5,
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 2,
})

export const titleStyle = {
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 12,
  fontWweight: '500',
  color: white(),
}

export const messageStyle = {
  display: 'flex',
  fontSize: 12,
  color: white(),
  lineHeight: 1.8,
  alignItems: 'center',
  justifyContent: 'center',
}

export const spinnerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 10,
}
